import { Link, matchPath, useLocation, useNavigate } from "react-router-dom";
import { Nav, Navbar } from "react-bootstrap";
import React, { useEffect, useState } from "react";

import { ActiveUsersService } from "apis/Services/ActiveUsersService";
import ButtonComponent from "components/button-component";
import { Affix, Drawer, Dropdown } from "antd";
import {
  BellOutlined,
  DownOutlined,
  UserOutlined,
} from "@ant-design/icons";
import LogoutIcon from "@mui/icons-material/LogoutOutlined";
import CompanyViewsNotificationTable from "components/company-views-notification-table";
import NotificationTable from "components/notification-table";
import logo from "assets/images/logo.svg";
import logoLanding from "assets/images/Koncurent-02.png";
import styles from "./nav.module.css";
import { useDispatch, useSelector } from "react-redux";
import { setUnsavedChangesModal } from "redux/project-reducer";
import ProjectSwitcher from "components/project-switcher";
import { CompanyAdminServices } from "apis/Services/CompanyAdminService";
import { PermissionServices } from "apis/Services/PermissionsService";
import { AuthStorage } from "utils/auth-storage";

function getProjectRouteInfo(pathname = "") {
  const match = pathname.match(
    /^\/main\/company\/([^/]+)\/projects\/([^/]+)(?:\/(.*))?$/,
  );

  if (!match) {
    return null;
  }

  return {
    companyId: match[1],
    projectId: match[2],
    remainder: (match[3] || "").replace(/^\/+|\/+$/g, ""),
  };
}

function isBaseProcurementLogRoute(pathname = "") {
  const routeInfo = getProjectRouteInfo(pathname);
  return Boolean(
    routeInfo && !routeInfo.remainder,
  );
}

function isCompanyViewsRoute(pathname = "") {
  return /^\/main\/company\/[^/]+\/company-dashboard\/?$/.test(pathname);
}

function isCompanyAdminRoute(pathname = "") {
  return /^\/main\/company\/[^/]+\/(company-admin|company-overview|company-schedule|company-dashboard)\/?$/.test(
    pathname,
  );
}

const NavbarComponent = () => {
  const [IsExpanded, setIsExpanded] = useState(false);
  const [isSideMenuVisible, setIsSideMenuVisible] = useState(false);
  const [shownTabs, setshownTabs] = useState([]);
  const [activeTab, setactiveTab] = useState({});
  const [warehouseSubscription, setWarehouseSubscription] = useState(null);
  const [hilytePageSubscription, setHilytePageSubscription] = useState(null);
  const [isLoadingPermissions, setIsLoadingPermissions] = useState(false);
  const {
    projectDetails,
    unsavedChanges,
    projectsAccessLevelValue,
    projectName: storedProjectName,
  } = useSelector((state) => state.projectDetails);
  const projectName = storedProjectName || projectDetails?.projectInfo;
  const accessLevel =
    projectsAccessLevelValue !== null &&
    projectsAccessLevelValue !== undefined &&
    projectsAccessLevelValue !== ""
      ? projectsAccessLevelValue
      : projectDetails?.usersInfo?.[0]?.accessLevel;

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let company_id = AuthStorage.getItem("company_id");
  const currentProjectRoute = getProjectRouteInfo(location.pathname);
  const isWorkspace = location.pathname.includes("/main");

  const readCompanyPermissionsTemplatesInfo = async () => {
    setIsLoadingPermissions(true);
    let code = AuthStorage.getItem("token");
    let loginEmail = AuthStorage.getItem("email");
    let data = {
      company_id,
      code,
      loginEmail,
    };

    try {
      const res = await PermissionServices.getCompanyPermissionsTemplate(data);
      setWarehouseSubscription(parseInt(res?.warehouseSubscription));
      setHilytePageSubscription(parseInt(res?.hilytePageSubscription));
    } catch (err) {
      console.log(err);
      setWarehouseSubscription(0);
      setHilytePageSubscription(0);
    } finally {
      setIsLoadingPermissions(false);
    }
  };

  const [logoUrl, setLogoUrl] = useState(null);

  const fetchLogo = async () => {
    const code = AuthStorage.getItem("token");
    const loginEmail = AuthStorage.getItem("email");
    const resolvedCompanyId = AuthStorage.getItem("company_id");

    // The landing page has no company context, so requesting its logo would call /getCompanyLogo/undefined.
    if (!resolvedCompanyId || !code || !loginEmail) {
      setLogoUrl(null);
      return;
    }

    try {
      const res = await CompanyAdminServices.getCompanyLogo({
        company_id: resolvedCompanyId,
        loginEmail,
        code,
      });

      let imgURL;
      if (res instanceof Blob) {
        imgURL = URL.createObjectURL(res);
      }
      setLogoUrl(imgURL);
    } catch (err) {
      console.error("Fetching logo failed:", err);
      setLogoUrl(null);
    }
  };

  useEffect(() => {
    fetchLogo();
  }, [location.pathname]);

  const getNavTabs = (warehouseSubscription) => ({
    home: [],
    category: [
      {
        id: 10,
        name: "Company Admin",
        value: "company-admin",
        to: `/main/company/${
          location?.pathname?.split("/")?.[3]
        }/company-overview`,
      },
      {
        id: 9,
        name: "Company Reports",
        value: "company-reports",
        to: `/main/company/${
          location?.pathname?.split("/")?.[3]
        }/company-reports`,
      },
      {
        id: 8,
        name: "Projects",
        value: "projects",
        to: `/main/company/${location?.pathname?.split("/")?.[3]}/projects`,
      },
      {
        id: 7,
        name: "Permissions",
        value: "permission",
        to: `/main/company/${
          location?.pathname?.split("/")?.[3]
        }/user-permission`,
      },
      ...(hilytePageSubscription === 1
        ? [
            {
              id: 6,
              name: "Hi-LYTE",
              value: "hilyte",
              to: `/main/company/${location?.pathname?.split("/")?.[3]}/hilyte`,
            },
          ]
        : []),
      ...(warehouseSubscription === 1
        ? [
            {
              id: 6,
              name: "Warehouse",
              value: "warehouse",
              to: `/main/company/${
                location?.pathname?.split("/")?.[3]
              }/warehouse-dashboard`,
            },
          ]
        : []),
    ],
    projectPages: [
      {
        id: 5,
        name: "Admin",
        value: "create-project",
        to: `/main/company/${
          location?.pathname?.split("/")?.[3]
        }/create-project/${location?.pathname?.split("/")?.[5]}`,
      },
      {
        id: 4,
        name: "Dashboard",
        value: "dashboard",
        to: `/main/company/${location?.pathname?.split("/")?.[3]}/projects/${
          location?.pathname?.split("/")?.[5]
        }/dashboard`,
      },
      {
        id: 3,
        name: "Procurement Log",
        value: "procurement-log",
        to: `/main/company/${location?.pathname?.split("/")?.[3]}/projects/${
          location?.pathname?.split("/")?.[5]
        }`,
      },
      {
        id: 2,
        name: "Directory",
        value: "directory",
        to: `/main/company/${location?.pathname?.split("/")?.[3]}/projects/${
          location?.pathname?.split("/")?.[5]
        }/directory`,
      },
      {
        id: 1,
        name: "Reports",
        value: "reports",
        to: `/main/company/${location?.pathname?.split("/")?.[3]}/projects/${
          location?.pathname?.split("/")?.[5]
        }/canned-reports`,
      },
    ],
  });

  const handleNavTabs = async () => {
    const tabs = [
      "company-admin",
      "company-reports",
      "hilyte",
      "warehouse",
      "warehouse-dashboard",
      "warehouse-inventory",
      "warehouse-job-sites",
      "warehouse-transfers",
      "warehouse-reports",
      "warehouse-settings",
      "warehouse-purchased-orders",
      "company-high-lead-time",
      "company-subcontractor-health",
      "company-item-deficiencies",
      "company-design-team-review-time",
      "company-submittal-issuing-review",
      "company-subcontract-signing",
      "company-upcoming-deliveries",
      "company-planned-issue-date",
      "company-overview",
      "company-schedule",
      "company-dashboard",
      "projects",
      "permissions",
      "user-permission",
      "company-directory",
      "company-permission",
      "Project-permission",
      "procurement-log",
    ];
    const category = location.pathname.split("/");
    const isWarehouseReportsRoute =
      location.pathname.includes("/warehouse-reports");

    if (location.pathname.includes("main")) {
      if (warehouseSubscription === null && !isLoadingPermissions) {
        await readCompanyPermissionsTemplatesInfo();
        return;
      }

      const navTabs = getNavTabs(warehouseSubscription);

      if (tabs.includes(category[category.length - 1]) || isWarehouseReportsRoute) {
        // Company level tabs
        setshownTabs(navTabs.category);
      } else {
        // Project level tabs
        setshownTabs(navTabs.projectPages);
      }
    } else if (location.pathname.includes("handle-auth-data")) {
      setshownTabs([]);
    } else {
      const navTabs = getNavTabs(warehouseSubscription);
      setshownTabs(navTabs.home);
    }
  };

  const handleActiveTab = () => {
    if (isCompanyAdminRoute(location.pathname)) {
      const companyAdminTab = shownTabs.find(
        (tab) => tab.value === "company-admin",
      );
      if (companyAdminTab) {
        setactiveTab(companyAdminTab);
        return;
      }
    }

    if (location.pathname.endsWith("/company-directory")) {
      const permissionsTab = shownTabs.find((tab) => tab.value === "permission");
      if (permissionsTab) {
        setactiveTab(permissionsTab);
        return;
      }
    }
    if (isBaseProcurementLogRoute(location.pathname)) {
      const procurementTab = shownTabs.find(
        (tab) => tab.value === "procurement-log",
      );
      if (procurementTab) {
        setactiveTab(procurementTab);
        return;
      }
    }

    if (location.pathname.includes("/warehouse-")) {
      const warehouseTab = shownTabs.find((tab) => tab.value === "warehouse");
      if (warehouseTab) {
        setactiveTab(warehouseTab);
        return;
      }
    }

    const findActive = shownTabs?.filter((item) => {
      return matchPath(item.to, location.pathname);
    });

    if (findActive.length) {
      if (findActive.length > 1) {
        setactiveTab(findActive[1]);
      } else {
        setactiveTab(findActive[0]);
      }
    }
  };

  useEffect(() => {
    handleActiveTab();
  }, [shownTabs]);

  useEffect(() => {
    handleNavTabs();
  }, [location.pathname, warehouseSubscription]);

  // Fetch permissions on component mount
  useEffect(() => {
    if (location.pathname.includes("main")) {
      if (warehouseSubscription === null) {
        readCompanyPermissionsTemplatesInfo();
      }
    }
  }, [location.pathname]);

  const handleLinkClicked = (x) => {
    if (unsavedChanges) {
      dispatch(setUnsavedChangesModal(x));
      return;
    } else {
      navigate(x);
      setIsExpanded(false);
    }
  };

  if (
    ["/login", "/forget-password", "/verify-code", "/resetPassword"].includes(
      location.pathname,
    ) ||
    location.pathname.includes("/main/sidePanelSubmittal")
  ) {
    return null;
  }

  const handleLogoClick = () => {
    let path;
    let pathRegex =
      /^(\/about(\/.*)?|\/home(\/.*)?|\/about-us(\/.*)?|\/handle-auth-data(\/.*)?|\/KoncurentSupport(\/.*)?|\/contact-us(\/.*)?|\/resetPassword(\/.*)?|\/)$/.test(
        location.pathname,
      );
    if (pathRegex) {
      path = "/";
    } else {
      path = `/main/company/${companyId}/projects`;
    }
    if (unsavedChanges) {
      dispatch(setUnsavedChangesModal(path));
      return;
    }
    navigate(path);
  };

  let project_id = currentProjectRoute?.projectId || "";
  const companyId = AuthStorage.getItem("company_id");
  const isCompanyViewsNotification = isCompanyViewsRoute(location.pathname);

  const shouldShowNavLinks =
    !location.pathname.includes("main") ||
    (warehouseSubscription !== null && !isLoadingPermissions);

  return (
    <Affix offsetTop={!location.pathname.includes("/main") ? 0 : -100}>
      <Navbar
        expand={isWorkspace ? "xl" : "lg"}
        className={`${styles.navbar} ${
          isWorkspace
            ? styles.workspaceNavbar
            : location.pathname.includes("/handle-auth-data")
              ? `${styles.simpleShadow} bg-white px-2`
              : "bg-black px-2"
        }`}
        expanded={IsExpanded}
        aria-label={isWorkspace ? "Workspace navigation" : "Main navigation"}
      >
        <Navbar.Brand className={isWorkspace ? styles.workspaceBrand : undefined}>
          {unsavedChanges ? (
            <button
              type="button"
              className={styles.brandButton}
              onClick={handleLogoClick}
              aria-label={isWorkspace ? "Go to projects" : "Go to home"}
            >
              <>
                {logoUrl ? (
                  <>
                    <img src={logoUrl} width={130} alt="company-logo" />
                  </>
                ) : (
                  <img src={logo} alt="koncurent-logo" />
                )}
              </>
            </button>
          ) : (
            <div className=" ">
              <Link
                to={
                  location.pathname.includes("/main")
                    ? `/main/company/${companyId}/projects`
                    : "/"
                }
              >
                {location.pathname.includes("/handle-auth-data") ? (
                  <img src={logo} alt="koncurent-logo" />
                ) : location.pathname.includes("/main") ? (
                  <>
                    {logoUrl ? (
                      <img src={logoUrl} width={130} alt="company-logo" />
                    ) : (
                      <img src={logo} alt="koncurent-logo" />
                    )}
                  </>
                ) : (
                  <img src={logoLanding} width={260} alt="koncurent-logo" />
                )}
              </Link>
            </div>
          )}
        </Navbar.Brand>

        <Navbar.Toggle
          className={`${
            isWorkspace ? styles.workspaceToggle : styles.navbarToggleCustom
          }`}
          aria-controls="basic-navbar-nav"
          aria-label="Toggle navigation"
          aria-expanded={IsExpanded}
          onClick={() => setIsExpanded(!IsExpanded)}
        />
        <Navbar.Collapse
          id="basic-navbar-nav"
          className={isWorkspace ? styles.workspaceCollapse : undefined}
        >
          <Nav
            className={
              isWorkspace
                ? styles.workspaceNavigation
                : "d-flex justify-content-between w-100"
            }
          >
            {!location.pathname.includes("/main") &&
              !location.pathname.includes("/procurementLogEntry") &&
              !location.pathname.includes("/registering-new-client") && (
                <div
                  className={`d-flex flex-column flex-md-row justify-content-center w-100 align-items-center ${styles.navLinks}`}
                >
                  <div className=" d-flex justify-content-center gap-2 gap-md-5 flex-column flex-md-row">
                    <a
                      className=" text-decoration-none text-white text-nowrap w-100 d-flex justify-content-center align-self-center "
                      style={{ fontSize: "0.9rem" }}
                      href="#how_it_works"
                    >
                      How It Works
                    </a>
                    <a
                      className=" text-decoration-none text-white text-nowrap w-100 d-flex justify-content-center align-self-center "
                      style={{ fontSize: "0.9rem" }}
                      href="#features"
                    >
                      Features
                    </a>
                    <a
                      className=" text-decoration-none text-white text-nowrap w-100 d-flex justify-content-center align-self-center "
                      style={{ fontSize: "0.9rem" }}
                      href="#integrations"
                    >
                      Integrations
                    </a>
                    <a
                      className=" text-decoration-none text-white text-nowrap w-100 d-flex justify-content-center align-self-center "
                      style={{ fontSize: "0.9rem" }}
                      href="#testimonials"
                    >
                      Testimonials
                    </a>
                  </div>
                </div>
              )}

            {isWorkspace && (
              <div className={styles.workspaceContext}>
                <ProjectSwitcher companyId={companyId} projectId={project_id} />
              </div>
            )}

            <div
              className={
                isWorkspace
                  ? styles.workspaceLinks
                  : "d-flex gap-1 flex-lg-row flex-column"
              }
            >
              {shouldShowNavLinks &&
                shownTabs.map((item, index) => {
                  const isActive =
                    activeTab.value === item.value &&
                    (item.value === "company-admin"
                      ? isCompanyAdminRoute(location.pathname)
                      : item.value === "procurement-log"
                        ? isBaseProcurementLogRoute(location.pathname)
                        : location.pathname.includes(activeTab.value) ||
                          (activeTab.value === "permission" &&
                            location.pathname.endsWith("/company-directory")));

                  return (
                    <a
                      key={"navLink" + item.id + index}
                      href={item.to}
                      className={`${isWorkspace ? styles.navLink : styles.navLinkLanding} ${
                        isActive
                          ? isWorkspace
                            ? styles.activeLink
                            : styles.activeLinkLanding
                          : ""
                      }`}
                      aria-current={isActive ? "page" : undefined}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClicked(item.to);
                      }}
                    >
                      {item.name}
                    </a>
                  );
                })}
            </div>

            {!isWorkspace &&
              !location.pathname.includes("handle-auth-data") &&
              !location.pathname.includes("registering-new-client") && (
              <div
                className={`d-flex align-items-center justify-content-center justify-content-md-end ms-3 mt-md-0 mt-2 align-self-center ${styles.actionsContainer}`}
                style={{ minWidth: "260px" }}
              >
                <ButtonComponent
                  title={"Login"}
                  className={`${styles.btn}`}
                  onClickAction={() => handleLinkClicked("/login")}
                />
              </div>
              )}
          </Nav>
        </Navbar.Collapse>

        {isWorkspace && (
          <div className={styles.workspaceActions}>
            <LoginContent
              openSideMenu={setIsSideMenuVisible}
              accessLevel={accessLevel}
            />
          </div>
        )}
      </Navbar>

      <Drawer
        placement="right"
        width={760}
        open={isSideMenuVisible}
        onClose={() => setIsSideMenuVisible(false)}
        className={styles.notificationDrawer}
        destroyOnClose
        title={
          <div className={styles.notificationDrawerTitle}>
            <span className={styles.notificationDrawerHeading}>
              {isCompanyViewsNotification
                ? "Company View Notifications"
                : "Project Notifications"}
            </span>
            <span className={styles.notificationDrawerSubheading}>
              {isCompanyViewsNotification
                ? "Custom procurement log activity and updates"
                : "Procurement activity and updates"}
            </span>
          </div>
        }
      >
        {isCompanyViewsNotification ? (
          <CompanyViewsNotificationTable company_id={companyId} />
        ) : project_id ? (
          <NotificationTable company_id={companyId} project_id={project_id} />
        ) : null}
      </Drawer>
    </Affix>
  );
};

export default NavbarComponent;

const LoginContent = ({ openSideMenu, accessLevel }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const openNotificationSideModal = () => {
    openSideMenu(true);
  };

  const [names, setNames] = useState([]);
  const [firstCharacters, setFirstCharacters] = useState("");

  useEffect(() => {
    let code = AuthStorage.getItem("token");
    let loginEmail = AuthStorage.getItem("email");
    const company_id = AuthStorage.getItem("company_id");
    let data = {
      company_id: company_id,
      loginEmail,
      code,
    };
    ActiveUsersService.UserInfo(data)
      .then((res) => {
        setNames(res);
        setFirstCharacters(
          `${res.firstName?.charAt(0) || ""}${res.lastName?.charAt(0) || ""}`,
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);
  const handleLogout = () => {
    setIsAccountMenuOpen(false);
    AuthStorage.clearAll();
    navigate("/");
  };
  const shouldBellshow =
    isBaseProcurementLogRoute(location.pathname) ||
    isCompanyViewsRoute(location.pathname);
  const isBellDisabled =
    !isCompanyViewsRoute(location.pathname) &&
    (accessLevel < 3 || accessLevel === undefined);
  const fullName = [names.firstName, names.lastName].filter(Boolean).join(" ");
  const email = names.loginEmail || AuthStorage.getItem("email");

  return (
    <div className={styles.accountControls}>
      {shouldBellshow && (
        <button
          type="button"
          className={styles.notificationBell}
          aria-label="Open notifications"
          title={isBellDisabled ? "Notifications require project admin access" : "Notifications"}
          disabled={isBellDisabled}
          onClick={openNotificationSideModal}
        >
          <BellOutlined />
        </button>
      )}

      <Dropdown
        open={isAccountMenuOpen}
        onOpenChange={setIsAccountMenuOpen}
        trigger={["click"]}
        placement="bottomRight"
        autoFocus
        menu={{
          "aria-label": "Account actions",
          items: [
            {
              key: "logout",
              label: "Log out",
              icon: <LogoutIcon sx={{ fontSize: 16 }} />,
              danger: true,
              onClick: handleLogout,
            },
          ],
        }}
        popupRender={(menu) => (
          <div className={styles.accountMenu}>
            <div className={styles.accountIdentity}>
              <span className={styles.accountName}>{fullName || "Your account"}</span>
              {email && <span className={styles.accountEmail}>{email}</span>}
            </div>
            {menu}
          </div>
        )}
      >
        <button
          type="button"
          className={styles.accountButton}
          aria-label="Open account menu"
          aria-haspopup="menu"
          aria-expanded={isAccountMenuOpen}
          title={fullName || "Your account"}
        >
          <span className={styles.letterContainer}>
            {firstCharacters || <UserOutlined />}
          </span>
          <DownOutlined className={styles.accountChevron} />
        </button>
      </Dropdown>
    </div>
  );
};
